import RegisterConsumer from './RegisterConsumer';

export default RegisterConsumer;
